export default __webpack_public_path__ + "static/media/QualifyHeader.963fefc2.png";